import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { signupUser } from "./authSlice";
import { useNavigate, Link } from "react-router-dom";

const Signup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [generalError, setGeneralError] = useState("");

  const validate = () => {
    const errs = {};
    const { name, phone, email, password, confirmPassword } = formData;

    if (!name.trim()) errs.name = "Name is required";
    if (!phone.trim()) {
      errs.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(phone)) {
      errs.phone = "Phone number must be 10 digits";
    }

    if (!email.trim()) {
      errs.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(email)) {
      errs.email = "Enter a valid email";
    }

    if (!password) errs.password = "Password is required";
    if (!confirmPassword) errs.confirmPassword = "Please confirm your password";
    else if (password !== confirmPassword) {
      errs.confirmPassword = "Passwords do not match";
    }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setGeneralError("");

    if (!validate()) return;

    try {
      const result = await dispatch(signupUser(formData));
      if (result.meta.requestStatus === "fulfilled") {
        navigate("/policy");
      } else {
        throw result.error;
      }
    } catch (err) {
      setGeneralError(err.message || "Signup failed");
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-box">
        <h1 className="login-title">Create Account</h1>
        <p className="login-subtitle">Signup to manage your clients</p>

        <form onSubmit={handleSubmit}>
          <input
            name="name"
            type="text"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
            className={errors.name ? "input-error" : ""}
          />
          {errors.name && <p className="error-text">{errors.name}</p>}

          <div className="input-wrapper">
            <span className="input-icon">🇮🇳</span>
            <span className="prefix-code">+91</span>
            <input
              name="phone"
              type="tel"
              placeholder="Phone Number"
              maxLength="10"
              value={formData.phone}
              onChange={handleChange}
              className={errors.phone ? "input-error" : ""}
              style={{ paddingLeft: "72px" }}
            />
          </div>
          {errors.phone && <p className="error-text">{errors.phone}</p>}

          <input
            name="email"
            type="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            className={errors.email ? "input-error" : ""}
          />
          {errors.email && <p className="error-text">{errors.email}</p>}

          <input
            name="password"
            type="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            className={errors.password ? "input-error" : ""}
          />
          {errors.password && <p className="error-text">{errors.password}</p>}

          <input
            name="confirmPassword"
            type="password"
            placeholder="Confirm Password"
            value={formData.confirmPassword}
            onChange={handleChange}
            className={errors.confirmPassword ? "input-error" : ""}
          />
          {errors.confirmPassword && (
            <p className="error-text">{errors.confirmPassword}</p>
          )}

          <button type="submit">Sign Up</button>

          {generalError && <p style={{ color: "red" }}>{generalError}</p>}
        </form>

        <div style={{ marginTop: "16px", textAlign: "center" }}>
          <Link to="/login" style={{ color: "#1976d2" }}>
            Already have an account? Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Signup;